<template>
	<button class="botao" @click="clicar" :class="classes" :disabled="disabled">
		<div v-if="this.$slots.antes">
			<slot name="antes" />
		</div>
		<div class="botao--icone">
			<div v-if="this.$slots.icone">
				<slot name="icone" />
			</div>
			{{ texto }}
		</div>
		<div v-if="this.$slots.depois">
			<slot name="depois" />
		</div>
	</button>
</template>

<script>
export default {
	name: 'Botao',
	props: {
		texto: String,
		transparente: Boolean,
		grande: Boolean,
		disabled: Boolean,
		pequeno: Boolean,
		mercadopago: Boolean
	},
	computed: {
		classes() {
			let classe = ''

			if (this.transparente) classe += 'botao--transparente'

			if (this.grande) classe += ' botao--grande'

			if (this.pequeno) classe += ' botao--pequeno'

			if (this.disabled) classe += ' botao--desabilitado'

			if (this.mercadopago) classe += ' botao--mercadopago'

			return classe
		},
	},
	methods: {
		clicar() {
			this.$emit('clicar')
		},
	},
}
</script>

<style scoped>
.botao {
	width: 100%;
	height: 2.5rem;
	background: var(--v-primary-base);
	border-radius: 13px;
	color: var(--v-textoBotoes-base);
	font-weight: bold;
	font-size: 16px;
	display: flex;
	justify-content: space-around;
	align-items: center;
	text-transform: uppercase;
	outline: none;
	transition: background 0.2s ease-in;
}

.botao:hover:not(.botao--desabilitado) {
	background-color: var(--v-primaryHover-base);
}

.botao--transparente {
	background: hsla(0, 0%, 100%, 0);
	border-radius: 13px;
	color: var(--v-primary-base);
}

.botao--transparente:hover:not(.botao--desabilitado) {
	background-color: hsl(0, 0%, 0%, 10%);
}

.botao--grande {
	height: 3.7rem;
	font-size: 24px;
}

.botao--pequeno {
	height: 1.5rem;
}

.botao:is(.botao--desabilitado) {
	background-color: #d9d9d9;
	color: #6d6767;
}

.botao--icone{
	display: flex;
	align-items: center;
	gap: 1rem;
}

.botao--mercadopago{
	height: 52px;
	text-transform: none;
	border-radius: 6px ;
}
</style>